<template>
  <div>
    <div>
      {{ $t('forms.labels.chooseComponent') }}
    </div>
    <v-tabs
      v-model="selectedTab"
      backgroundColor="transparent"
      dark
      grow
      color="red"
    >
      <v-tab
        v-for="(item, index) in items"
        :key="index"
        style="color: #26384B"
      >
        {{ item.component.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="selectedTab"
      style=" padding-top: 15px"
    >
      <v-tab-item
        v-for="(item, index) in items"
        :key="index"
      >
        <div style="padding: 15px,">
          <v-row>
            <v-col>
              <VTextField
                :value="item.analysisType.formula"
                :label="$t('forms.labels.formula')"
                :disabled="true"
                outlined
              />
            </v-col>
          </v-row>
          <div>{{ $t('analyses.definitionOfVariables') }}</div>
          <div style="margin: 1%">
            <v-row style="background-color: #26384b; color: #fff;">
              <v-col>
                {{ $t('analyses.variables') }}
              </v-col>
              <v-col>
                {{ $t('forms.labels.analysisTypes') }}
              </v-col>
            </v-row>

            <v-row
              v-for="variable in item.variables"
              :key="variable._id"
              style="border: 1px solid #26384b"
            >
              <v-col>
                {{ variable.name }}
              </v-col>
              <v-col style="border-left: 1px solid #26384b">
                {{ variable.analysisType.name[userLang] || variable.analysisType.name[teamMainLang] }}
                ( {{ variable.networkDetail.name }} - {{ variable.componentDetail.name }} )
                value: {{ variable.value }}
              </v-col>
            </v-row>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import VTextField from '../shared/widgets/forms/VuetifyInputs/VTextField.vue';


export default {
    components: { VTextField },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedTab: 0,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
            'network',
        ]),
    },
};
</script>
